import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { TSEntryForm } from './TSEntryForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

function TimesheetAddPage() {
    const {t} = useTranslation()

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/timesheet'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{t('add_record_title')}</AppTitle>

            <div className="rounded-content-body p-3">
                <TSEntryForm/>
            </div>

        </AppLayout>
    )
}

export default TimesheetAddPage
